module.exports = __webpack_public_path__ + "img/9.0503aed1.jpg";